module.exports = __webpack_public_path__ + "static/media/topic-complete.226228b2.mp3";